export const TotemData = [
  {
    state: "Montevideo",
    addreses: [
      {
        address: "Devoto Portones",
        details: "(Av. Italia 5779) - Autoservicio todos los dias de 8 a 22 hs",
      },
      {
        address: "Devoto Sayago",
        details: "(Camino Ariel 4626) - Autoservicio todos los dias de 8 a 22 hs",
      },
      {
        address: "Disco Fresh Market Av. Italia",
        details: "(Magariños Cervantes 2052) - Autoservicio todos los dias de 8 a 22 hs",
      },
      {
        address: "Farmashop 28",
        details: "(8 de octubre 3268) - Autoservicio todos los dias de 8 a 22 hs",
      },
      {
        address: "Farmashop 57",
        details: "(Av. Gral. Rivera 3500) - Autoservicio todos los dias de 8 a 22 hs",
      },
      {
        address: "FreshMarket Punta Carretas Shopping",
        details: "(Guipúzcoa 311) - Autoservicio todos los dias de 8 a 22 hs",
      },
      {
        address: "18 de Julio",
        details: "(Av. 18 de Julio 1321) - Autoservicio todos los dias de 6 a 22 hs",
      },
      {
        address: "Ciudad Vieja - 25 de mayo",
        details: "(25 de mayo 501) - Autoservicio todos los dias de 9 a 19 hs",
      },
      {
        address: "Casa Central",
        details: "(Av. 18 de Julio 999 esq. Julio Herrera y Obes) - Autoservicio todos los dias de 6 a 22 hs",
      },
      {
        address: "Paso Molino",
        details: "(Av. Agraciada 4228) - Autoservicio lunes a viernes de 9 a 19 hs",
      },
      {
        address: "Pablo de Maria",
        details: "(Av. 18 de Julio 2002) - Autoservicio todos los dias de 6 a 22 hs",
      },
      {
        address: "UCU",
        details: "(Av. 8 de Octubre 2738) - Autoservicio lunes a viernes de 11 a 18 hs",
      },
      {
        address: "Ombú",
        details: "(Br. España 2640) - Autoservicio lunes a viernes de 13 a 17 hs",
      },
      {
        address: "Puerto del Buceo",
        details: "(26 de Marzo 3540) - Autoservicio lunes a viernes de 13 a 17 hs",
      },
      {
        address: "Géant Nuevocentro",
        details: "(Av. Luis Alberto de Herrera y Bv. Artigas) - Autoservicio todos los dias de 8 a 22 hs",
      },
      {
        address: "Carrasco",
        details: "(Arocena 1577) - Autoservicio lunes a viernes de 6 a 22 hs",
      },

    ],
  },
  {
    state: "Canelones",
    addreses: [
      {
        address: "Car One",
        details: "(Interbalnearia esq. Cno. de los Horneros) - Autoservicio lunes a sábados de 8 a 21 hs",
      },
      {
        address: "Géant Roosevelt",
        details: "(Av. a la Playa, 15000 Ciudad de la Costa) - Autoservicio todos los dias de 8 a 22 hs",
      },
      {
        address: "Las Piedras",
        details: "(Av. Gral Artigas 601, Las Piedras) - Autoservicio todos los dias de 8 a 22 hs",
      },
    ],
  },
  {
    state: "Maldonado",
    addreses: [
      {
        address: "Roosevelt",
        details: "(Av. Roosevelt y Parada 11, Punta del Este) - Autoservicio todos los dias de 6 a 22 hs",
      },
    ],
  },
];